import type { Skill } from "@cohesive/api-client";

type DeleteSkillMutate = {
  mutate: (
    skillId: string,
    options?: {
      onSuccess?: () => void;
      onError?: () => void;
    },
  ) => void;
};

/**
 * Archive many skills with `allSettled` semantics so one failure cannot
 * abort later rows or leave earlier archives stranded with an open dialog.
 */
export async function archiveSkillsSettled(
  skills: Skill[],
  deleteSkill: DeleteSkillMutate,
): Promise<{ archived: Skill[]; failed: number }> {
  const settled = await Promise.allSettled(
    skills.map(
      (skill) =>
        new Promise<Skill>((resolve, reject) => {
          deleteSkill.mutate(skill.id, {
            onSuccess: () => resolve(skill),
            onError: () => reject(new Error("delete failed")),
          });
        }),
    ),
  );

  const archived = settled
    .filter((r): r is PromiseFulfilledResult<Skill> => r.status === "fulfilled")
    .map((r) => r.value);

  return { archived, failed: settled.length - archived.length };
}
